








































import { Vue, Component, Prop } from "vue-property-decorator";
import Render from "./render.vue";
@Component({
  name: "LayoutCell",
  components: { Render }
})
export default class LayoutCell extends Vue {
  @Prop({
    required: true
  })
  private cell!: App.WebForm.Cell;

  @Prop({
    required: true
  })
  private options!: App.WebForm.Config;

  @Prop({
    required: true
  })
  private config!: App.WebForm.ServiceOriginConfig;

  @Prop({
    required: true
  })
  private model!: "preview" | "normal";

  /**
   * 当前组件是否用于放置组件
   * 根据cell.rows.length === 0 来判断
   * @returns { boolean }
   */
  get isWidgetLayout() {
    return !this.cell.rows || this.cell.rows.length === 0;
  }

  /**
   * 获取当前组件需要放置的widget
   * 1、isWidgetLayout = true
   * 2、能在widgets中查找到cellid为当前id的widget
   * @returns { App.WebForm.Widget | null }
   */
  get widget(): App.WebForm.Widget | null {
    if (!this.isWidgetLayout) {
      return null;
    }
    return this.options.widgets.find((d) => d.cellId === this.cell.id) || null;
  }

  get style() {
    const {
      options: { style }
    } = this;

    if (!this.isWidgetLayout) return { verticalAlign: this.cell.align };

    // 处理老版本配置默认没有底部边距的问题
    let paddingBottom = style.cellPaddingBottom;
    if (!this.options.version && style.cellPaddingBottom === 0) {
      paddingBottom = style.cellPaddingTop;
    }

    return {
      verticalAlign: this.cell.align,
      paddingLeft: style.cellPaddingLeft + "px",
      paddingTop: style.cellPaddingTop + "px",
      paddingRight: style.cellPaddingRight + "px",
      paddingBottom: paddingBottom + "px",
      ...(style.grid.visible
        ? {
            borderColor: style.grid.color,
            borderStyle: style.grid.style,
            borderLeftWidth: 0 + "px",
            borderTopWidth: 0 + "px",
            borderBottomWidth: style.grid.width + "px",
            borderRightWidth: style.grid.width + "px"
          }
        : {})
    };
  }
}
